import { apiClient } from './axios';

export interface Medication {
  name: string;
  dosage: string;
  frequency: string;
  duration: string;
  route?: string;
  instructions?: string;
}

export type PrescriptionStatus = 'issued' | 'revoked';

export interface Prescription {
  id: string;
  bookingId?: string | null;
  petId: string;
  petName: string;
  petSpecies?: string | null;
  petBreed?: string | null;
  ownerName?: string | null;
  businessId: string;
  businessName: string;
  businessAddress?: string | null;
  issuedByClerkId: string;
  issuedByName: string;
  issuedByTitle?: string | null;
  issuedByLicenseNo?: string | null;
  signatureImageUrl?: string | null;
  signerName?: string | null;
  signedAt?: string | null;
  prescriptionNumber: string;
  diagnosis?: string | null;
  medications: Medication[];
  instructions?: string | null;
  remarks?: string | null;
  status: PrescriptionStatus;
  issuedAt: string;
  validFrom?: string | null;
  validUntil?: string | null;
  revokedAt?: string | null;
  revokedReason?: string | null;
  createdAt: string;
  updatedAt: string;
}

// Get all prescriptions for the authenticated user's pets
export async function listMyPrescriptions(): Promise<Prescription[]> {
  const res = await apiClient.get<{ prescriptions: Prescription[] }>('/prescriptions');
  return res.data.prescriptions ?? [];
}

// Get prescriptions for a single pet
export async function listPetPrescriptions(petId: string): Promise<Prescription[]> {
  const res = await apiClient.get<{ prescriptions: Prescription[] }>(
    `/pets/${petId}/prescriptions`,
  );
  return res.data.prescriptions ?? [];
}

// Get prescriptions attached to a specific booking
export async function listBookingPrescriptions(bookingId: string): Promise<Prescription[]> {
  const res = await apiClient.get<{ prescriptions: Prescription[] }>(
    `/bookings/${bookingId}/prescriptions`,
  );
  return res.data.prescriptions ?? [];
}

// Get a single prescription by id
export async function getPrescription(id: string): Promise<Prescription> {
  const res = await apiClient.get<{ prescription: Prescription }>(`/prescriptions/${id}`);
  return res.data.prescription;
}
